const s = new URL("../../../assets/icon-okx-ZbWsw-B5.svg", import.meta.url).href;
export {
  s as default
};
//# sourceMappingURL=icon-okx.svg.js.map
